import { toast } from 'vue3-toastify';

/**
 * Show a loading toast that can later be updated.
 * @param {string} message - Initial loading message.
 * @returns {string} - Toast ID to update later.
 */
export const notifyLoading = (toastId, message = 'Loading...') => {
    if (toast.isActive(toastId)) {
        toast.update(toastId, {
            render: message,
            isLoading: true,
            autoClose: false,
        });
        return toastId;
    } else {
        return toast.loading(message, {
            toastId: toastId,
            position: 'top-right',
            autoClose: false,
            closeOnClick: false,
            draggable: false,
        });
    }
};

/**
 * Update a loading toast to success.
 * @param {string} toastId - The toast ID to update.
 * @param {string} message - Success message.
 */
export const notifySuccessUpdate = (toastId, message) => {
    toast.update(toastId, {
        render: message,
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 2000,
    });
};

/**
 * Update a loading toast to error.
 * @param {string} toastId - The toast ID to update.
 * @param {string} message - Error message.
 */
export const notifyErrorUpdate = (toastId, message) => {
    toast.update(toastId, {
        render: message,
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 3000,
    });
};

/**
 * Show an info toast.
 * @param {string} message - Info message.
 */
export const notifyInfo = (message) => {
    toast.info(message, {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        draggable: true,
    });
}

/**
 * Show an error toast.
 * @param {string} message - Info message.
 */
export const notifyError = (message) => {
    toast.error(message, {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        draggable: true,
    });
}


/**
 * Show a success toast.
 * @param {string} message - Success message.
 */
export const notifySuccess = (message) => {
    toast.success(message, {
        position: 'top-right',
        autoClose: 3000,
        closeOnClick: true,
        draggable: true,
    });
}
